<template>
  <v-row
    no-gutters
    class="py-2"
    :class="{ 'list--striped px-3': striped }"
  >
    <v-col
      cols="7"
      style="max-width: 300px"
      class="grey--text pr-4"
    >
      {{ label }}
    </v-col>
    <v-col cols="9">
      <slot />
    </v-col>
  </v-row>
</template>
<script>
  export default {
    name: 'YachtDataRow',
    props: {
      label: {
        type: String,
        required: true
      },
      striped: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
